import { render, staticRenderFns } from "./IndexTableSkeleton.vue?vue&type=template&id=e74e0234&scoped=true&"
import script from "./IndexTableSkeleton.vue?vue&type=script&lang=js&"
export * from "./IndexTableSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74e0234",
  null
  
)

export default component.exports